export enum OutputTypes {
    DEFAULT = 'DEFAULT',
    PLAIN_TEXT = 'PLAIN_TEXT',
    JSON_FULL_ENTITY = 'JSON_FULL_ENTITY',
    JSON_BASIC_ENTITY = 'JSON_BASIC_ENTITY',
}
